/*
 * Copyright (c) 2024. Bolmate B.V.
 */

import React, {useContext, useEffect, useState} from 'react';
import {Navigate} from 'react-router';
import {AppContext} from '../misc/appContext';
import {LOGIN_ROUTE, REFER_A_FRIEND_ROUTE} from '../../util/constants';
import {referAFriend} from '../../util/requestSender';
import {ResponseData} from '@dvrd/dvr-controls';
import {createErrorMessage} from '../../util/utils';
import ReferAFriend from './referAFriend';
import {onSetCrumbs} from '../../util/events';
import {showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {useTranslation} from 'react-i18next';

export default function ReferAFriendController() {
    const {user} = useContext(AppContext).userContext;
    const {t} = useTranslation();
    const [friendEmail, setFriendEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [createdAccountAccepted, setCreateAccountAccepted] = useState(false);
    const [paidSubAccepted, setPaidSubAccepted] = useState(false);
    const [firstPaymentAccepted, setFirstPaymentAccepted] = useState(false);

    function onChangeFriendEmail(value: string) {
        setFriendEmail(value);
    }

    function onChangeAccountCreatedAccepted() {
        setCreateAccountAccepted(!createdAccountAccepted);
    }

    function onChangePaidSubAccepted() {
        setPaidSubAccepted(!paidSubAccepted);
    }

    function onChangeFirstPaymentAccepted() {
        setFirstPaymentAccepted(!firstPaymentAccepted);
    }

    function onSubmit() {
        setLoading(true);
        referAFriend({
            data: {friend_email: friendEmail},
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    reset();
                    showSnackbar(
                        t(
                            'referAFriend.snackbar',
                            'Bedankt! Het verzoek is ingediend, we nemen z.s.m. contact met je op.'
                        )
                    );
                } else
                    showDialog(
                        createErrorMessage(
                            data.message ??
                                t('referAFriend.submitFailedMessage', 'Het indienden van het verzoek is niet gelukt.')
                        ),
                        t('referAFriend.submitFailed', 'Indienen mislukt')
                    );
            }
        });
    }

    function reset() {
        setFriendEmail('');
        setPaidSubAccepted(false);
        setFirstPaymentAccepted(false);
    }

    useEffect(() => {
        onSetCrumbs([{label: t('referAFriend.crumb', 'Refer a friend'), route: REFER_A_FRIEND_ROUTE}]);
    }, []);
    if (!user) return <Navigate to={LOGIN_ROUTE} />;

    return (
        <ReferAFriend
            onChangeFriendEmail={onChangeFriendEmail}
            onChangePaidSubAccepted={onChangePaidSubAccepted}
            onChangeFirstPaymentAccepted={onChangeFirstPaymentAccepted}
            onSubmit={onSubmit}
            onChangeAccountCreatedAccepted={onChangeAccountCreatedAccepted}
            friendEmail={friendEmail}
            paidSubAccepted={paidSubAccepted}
            firstPaymentAccepted={firstPaymentAccepted}
            loading={loading}
            user={user}
            createdAccountAccepted={createdAccountAccepted}
        />
    );
}
